<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("customization") }}
      </div>
      <router-link class="btn-blue" to="/fnb/customization"
        >{{ $t("customization") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_code"
                name="itemcode"
                id="itemcode"
                v-validate="'required|alpha_dash'"
                disabled
              />
              <label>{{ $t("itemcode") }}</label>
            </div>
            <!-- <Tooltip :title="$t('fnbitems_itemCode_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemcode')">{{
              errors.first("itemcode")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_name"
                @input="onChangeItemName($event, 'name')"
                name="itemname"
                id="itemname"
                v-validate="'required'"
              />
              <label>{{ $t("itemname") }}</label>
            </div>
            <!-- <Tooltip :title="$t('itemname')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemname')">{{
              errors.first("itemname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fnb_item.item_description"
                @input="onChangeItemName($event, 'desc')"
                name="itemdesc"
                id="itemdesc"
                v-validate="'required'"
              />
              <label>{{ $t("description") }}</label>
            </div>
            <!-- <Tooltip :title="$t('fnbitems_itemdescription_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('itemdesc')">{{
              errors.first("itemdesc")
            }}</span>
          </p>
        </div>
        <section
          class="mb-2 col-lg-12 col-xl-12 align-self-center"
          v-if="false"
        >
          <div class="bn-tabs-nav">
            <button
              v-for="(fnbContent, fnbContentIndex) in FnbItemContent"
              :key="fnbContentIndex"
              :class="[
                'btn-tab-title ',
                { active: fnbContentIndex == activeClass },
              ]"
              @click.prevent.stop="onChangeTabHandler($event, fnbContentIndex)"
            >
              <strong>
                <span
                  :class="
                    fnbContent.langauge.toLowerCase() !== 'english'
                      ? notempty[fnbContentIndex]
                        ? ''
                        : 'text-danger'
                      : ''
                  "
                  >{{ fnbContent.langauge }}</span
                >
              </strong>
            </button>
          </div>
          <div class="bn-tabs-content">
            <div
              v-for="(fnbContent, fnbContentIndex) in FnbItemContent"
              :key="fnbContentIndex"
            >
              <div v-if="fnbContentIndex === activeClass">
                <div class="row">
                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.item_name"
                          name="itemnamelang"
                          id="itemnamelang"
                          @input="
                            CheckEmptyContent(fnbContent, fnbContentIndex)
                          "
                          v-validate="
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                        />
                        <label>{{ $t("itemname") }}</label>
                      </div>
                      <!-- <Tooltip :title="$t('itemname')" /> -->
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('itemnamelang')">{{
                        errors.first("itemnamelang")
                      }}</span>
                    </p>
                    <p
                      v-if="fnbContent.langauge.toLowerCase() !== 'english'"
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.item_description"
                          name="itemdesclang"
                          id="itemdesclang"
                          @input="
                            CheckEmptyContent(fnbContent, fnbContentIndex)
                          "
                          v-validate="
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                        />
                        <label>{{ $t("description") }}</label>
                      </div>
                      <!-- <Tooltip
                        :title="$t('fnbitems_itemdescription_tooltip')"
                      /> -->
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && errors.has('itemdesclang')">{{
                        errors.first("itemdesclang")
                      }}</span>
                    </p>
                    <p
                      v-if="fnbContent.langauge.toLowerCase() !== 'english'"
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="dropdown-curve-container">
            <label :class="fc_parent_label.length > 0 ? 'shift-up' : ''">{{
              $tc("category", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="fc_parent_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Categories"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchFoodCategories()"
                    v-on:keydown="onSearchFoodCategories()"
                    v-on:search="onSearchFoodCategories()"
                    v-model="searchFoodCategories"
                  />
                </div>
                <b-dropdown-item
                  v-for="(fc, fcIndex) in ms_food_categories"
                  :key="fcIndex"
                  href="#"
                  @click="
                    fnb_item.fc_id = fc.fc_id;
                    fc_parent_label = fc.fc_category;
                    searchFoodCategories = '';
                    onSearchFoodCategories();
                  "
                  >{{ fc.fc_category }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('fnbitems_foodcategory_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && fc_parent_label.length == 0"
                >Please Select Food Category.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex justify-content-between align-item-center">
            <label
              class="material-file-upload"
              @click.prevent.stop="setModalData(280, 460)"
            >
              <div
                class="label"
                v-bind:class="{
                  'shift-up': fnb_item.item_image_url,
                }"
              >
                {{ "Item Image" }}
              </div>
              <div class="uploaded-file-name">
                <div class="text-truncate pt-2 image_url_text">
                  {{ fnb_item.item_image_url }}
                </div>
              </div>
            </label>

            <!-- <Tooltip
              class="mt-2"
              :title="
                `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
              "
            /> -->
            <img
              width="40"
              height="40"
              class="rounded ml-2"
              @click="showFnbImage()"
              :src="_GetImagePath(fnb_item.item_image_url)"
              v-if="fnb_item.item_image_url.length > 0"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
            <img
              v-else
              width="35"
              height="35"
              class="rounded ml-2"
              alt="Empty Image"
              src="@/assets/img/icons/empty-image.svg"
              v-b-tooltip.hover.top="
                'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
              "
            />
          </div>
          <p class="error_message">
            <!-- <span v-if="submitted && fnb_item.item_image_url.length == 0"
              >Please Select Food Image File.</span
            > -->
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.item_is_active"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-4 align-self-center mb-3" v-if="false">
          <div class="d-flex align-items-center mb-4">
            <span>{{ $t("isSundry") }}</span>
            <b-form-checkbox
              class="j-checkbox ml-3"
              v-model="fnb_item.is_sundry"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-3" v-if="false">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("isveg") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.item_is_veg"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div
          class="col-lg-6 col-xl-4 align-self-center mb-3"
          v-if="fnb_item.item_is_veg && false"
        >
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("includesegg") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.includes_egg"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div
          class="col-lg-6 col-xl-4 align-self-center mb-3"
          v-if="fnb_item.item_is_veg && false"
        >
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("isPackageitem") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fnb_item.is_package_item"
              type="checkbox"
              class="j-checkbox ml-2"
              checked
            />
            <!-- <span class="switch-slider"></span>
            </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12">
          <div class="section-title mb-3">
            {{ $tc("price", 1) }} {{ $tc("details", 2) }}
          </div>
        </div>

        <div
          v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
          :key="CinemaIndex"
          class="col-md-12 mb-4 chargeSettingRow"
        >
          <div class="row">
            <!-- SELECT CINEMA -->
            <div class="col-11">
              <div class="row chargeSettingInnerWrap">
                <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                  <div class="dropdown-curve-container">
                    <multiselect
                      :options="cinemaListCopy"
                      v-model="singleCinema.selectedCinemas"
                      :searchable="true"
                      label="cine_name"
                      track-by="cine_id"
                      placeholder="Select Cinema"
                      @input="onDropdownChange($event, CinemaIndex)"
                      :allowEmpty="false"
                      :showLabels="false"
                      :disabled="
                        role_id == 1 || role_id == 2
                          ? false
                          : singleCinema.cinemaFlag
                      "
                    ></multiselect>
                    <p
                      v-if="
                        submitted && singleCinema.selectedCinema.length == 0
                      "
                      class="error_message"
                    >
                      Please Select Cinema.
                    </p>
                  </div>
                </div>

                <!-- SELECT RECIPE -->
                <div class="col-lg-4 col-xl-3 align-self-center">
                  <div class="dropdown-curve-container">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <multiselect
                        :options="recipes"
                        :searchable="true"
                        :placeholder="
                          singleCinema.recipe_label &&
                          singleCinema.recipe_label.length > 0
                            ? singleCinema.recipe_label
                            : 'Recipe Optional'
                        "
                        label="recipe_name"
                        track-by="recipe_id"
                        @select="
                          onSelectFnbItem($event, CinemaIndex);
                          fnb_item.recipe_id = $event.recipe_id;
                          singleCinema.recipe_label = $event.recipe_name;
                        "
                        :allowEmpty="false"
                        :showLabels="false"
                        :disabled="
                          role_id == 1 || role_id == 2
                            ? false
                            : singleCinema.cinemaFlag
                        "
                      ></multiselect>
                    </div>
                    <p class="error_message">
                      <span></span>
                    </p>
                  </div>
                </div>

                <!-- ITEM COST PRICE -->
                <div class="col-lg-4 col-xl-2 align-self-center">
                  <div class="d-flex align-items-center mb-4">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        v-model="singleCinema.itemcost_price.costprice"
                        name="costprice"
                        id="costprice"
                        v-validate="'required|decimal'"
                        :disabled="
                          role_id == 1 || role_id == 2
                            ? false
                            : singleCinema.cinemaFlag
                        "
                      />
                      <label>{{ $t("itemcostprice") }}</label>
                    </div>
                    <!-- <Tooltip :title="$t('itemcostprice_costPrice')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('costprice')"
                    class="error_message"
                  >
                    {{ errors.first("costprice") }}
                  </p>
                </div>

                <!-- FNB PRICE -->
                <div class="col-lg-4 col-xl-2 align-self-center mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        v-model="singleCinema.ratecard.frc_amount"
                        v-on:keyup="onChangeRatecardAmount($event, CinemaIndex)"
                        type="text"
                        name="cardamount"
                        id="cardamount"
                        v-validate="{
                          required: 'required',
                          regex: '[0-9]|[0-9]*\\.[0-9]*$',
                        }"
                        :disabled="
                          role_id == 1 || role_id == 2
                            ? false
                            : singleCinema.cinemaFlag
                        "
                      />
                      <label>{{ $t("amount") }}</label>
                    </div>
                    <!-- <Tooltip :title="$t('tooltip')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('cardamount')"
                    class="error_message"
                  >
                    {{ errors.first("cardamount") }}
                  </p>
                </div>

                <div
                  v-if="singleCinema.cinemaFlag && false"
                  class="col-lg-4 col-xl-2 align-self-center mb-4"
                >
                  <div class="d-flex align-items-center">
                    <div
                      v-if="
                        singleCinema.ratecard.frc_pas_setting_name &&
                        singleCinema.ratecard.frc_pas_setting_name.length > 0
                      "
                      class="input-material"
                    >
                      <input
                        placeholder="."
                        type="text"
                        v-model="singleCinema.ratecard.frc_pas_setting_name"
                        name="frc_pas_setting_name"
                        id="frc_pas_setting_name"
                        :disabled="true"
                      />
                      <label>{{ "Tax Setting" }}</label>
                    </div>
                  </div>
                </div>

                <!-- CHARGE SETTING NAME -->
                <div v-else class="col-lg-4 col-xl-2 align-self-center mb-3">
                  <div class="dropdown-curve-container pr-28px">
                    <!-- <label
                  :class="singleCinema.selectedChargeSettingName.length > 0 ? 'shift-up' : '' "
                >{{ $tc('chargesettingname', 1) }}</label>-->
                    <!-- <b-dropdown
                  :text="singleCinema.selectedChargeSettingName"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in singleCinema.pas_setting_name_list"
                    :key="dropdownIndex"
                    href="#"
                    @click="onChangeSettingName($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item>
                </b-dropdown>-->
                    <multiselect
                      :options="singleCinema.pas_setting_name_list"
                      :searchable="true"
                      :placeholder="
                        singleCinema.selectedChargeSettingName.length > 0
                          ? singleCinema.selectedChargeSettingName
                          : 'Select Charge Setting'
                      "
                      label="pas_charge_setting_name"
                      track-by="pas_id"
                      @select="onChangeSettingName($event, $event, CinemaIndex)"
                      :allowEmpty="false"
                      :showLabels="false"
                    ></multiselect>
                    <p
                      v-if="
                        submitted &&
                        singleCinema.selectedChargeSettingName.length == 0
                      "
                      class="error_message"
                    >
                      Please Select Charge Setting Name.
                    </p>
                  </div>
                </div>

                <!-- FROM DATE -->
                <div class="col-lg-4 col-xl-3 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="singleCinema.ms_fnb_price.fp_from_date"
                          @click="resetFromDate(CinemaIndex)"
                        >
                          ✖
                        </button>
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="singleCinema.ms_fnb_price.fp_from_date"
                          name="fdate1"
                          id="fdate1"
                          typeable
                          v-validate="'required'"
                          :disabled="
                            role_id == 1 || role_id == 2
                              ? false
                              : singleCinema.cinemaFlag
                          "
                        ></Datepicker>
                        <label
                          :class="
                            typeof singleCinema.ms_fnb_price.fp_from_date ===
                            'object'
                              ? 'active'
                              : ''
                          "
                          >From Date</label
                        >
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t('fnbpricing_fromdate')" /> -->
                  </div>
                  <p
                    v-if="submitted && errors.has('fdate1')"
                    class="error_message"
                  >
                    {{ errors.first("fdate1") }}
                  </p>
                </div>

                <!-- TO DATE -->
                <div class="col-lg-4 col-xl-3 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <button
                          class="btn-clearDate"
                          v-if="singleCinema.ms_fnb_price.fp_to_date"
                          @click="resetToDate(CinemaIndex)"
                        >
                          ✖
                        </button>
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="singleCinema.ms_fnb_price.fp_to_date"
                          name="tdate1"
                          id="tdate1"
                          typeable
                          :disabled="
                            role_id == 1 || role_id == 2
                              ? false
                              : singleCinema.cinemaFlag
                          "
                        ></Datepicker>
                        <label
                          :class="
                            typeof singleCinema.ms_fnb_price.fp_to_date ===
                            'object'
                              ? 'active'
                              : ''
                          "
                          >To Date</label
                        >
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t('fnbpricing_todate')" /> -->
                  </div>
                  <p class="text-muted fs-12">({{ $t("optional") }})</p>
                </div>

                <template v-if="showErpColumns">
                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.report_code"
                          name="report_code"
                          id="report_code"
                          v-validate=""
                        />
                        <label>{{ "Report Code" }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.gl_account"
                          name="gl_account"
                          id="gl_account"
                          v-validate=""
                        />
                        <label>{{ "GL Account" }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-xl-2 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          style="text-align: right"
                          placeholder="."
                          type="text"
                          v-model="singleCinema.gl_desc"
                          name="gl_desc"
                          id="gl_desc"
                          v-validate=""
                        />
                        <label>{{ "GL Desc." }}</label>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- CHARGE IS INCLUSIVE SWITCH -->
                <div class="col-lg-4 col-xl-3 align-self-center">
                  <div class="d-flex align-items-center">
                    <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    <b-form-checkbox
                      class="j-checkbox"
                      unchecked-value="N"
                      value="Y"
                      v-model="singleCinema.ratecard.frc_is_active_inclusivtax"
                      name="check-button"
                      @change="OnSwitchHandler($event, CinemaIndex)"
                      switch
                      :disabled="
                        role_id == 1 || role_id == 2
                          ? false
                          : singleCinema.cinemaFlag
                      "
                    ></b-form-checkbox>
                  </div>
                </div>

                <div
                  class="col-md-12 mt-4"
                  v-if="
                    singleCinema.cinemaChargesList &&
                    singleCinema.cinemaChargesList.length
                  "
                >
                  <table class="table table-bordered col-xl-8">
                    <tbody>
                      <tr
                        v-for="(
                          cinemaCharge, cinemaChargesListIndex
                        ) in singleCinema.cinemaChargesList"
                        :key="cinemaChargesListIndex"
                        class="main_border_edit"
                      >
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                          "
                        >
                          {{ cinemaCharge.ct_name }}
                        </td>
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                            text-align: right;
                          "
                        >
                          {{ cinemaCharge.pas_charge_value }}
                          {{
                            cinemaCharge.pas_is_percentage === "Y" ? "%" : ""
                          }}
                        </td>
                        <td
                          class=""
                          style="
                            padding: 4px 10px;
                            color: black;
                            font-weight: bold;
                            text-align: right;
                          "
                        >
                          {{
                            parseFloat(cinemaCharge.cinemacharges || 0).toFixed(
                              4
                            ) || 0
                          }}
                        </td>
                      </tr>
                      <tr class="main_border_edit">
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Net Amount:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                parseFloat(
                                  singleCinema.ratecard.frc_net_amount || 0
                                ).toFixed(MIN_FRACTION_DIGITS) || 0
                              }}</span
                            >
                          </div>
                        </td>
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Gross Total:</span>
                            <span
                              >{{ currencyData.curr_code }}
                              {{
                                parseFloat(
                                  singleCinema.ratecard.frc_total_amount || 0
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}</span
                            >
                          </div>
                        </td>
                        <td style="padding: 4px 10px">
                          <div>
                            <span class="font-weight-bold">Food Cost %:</span>
                            <span v-if="singleCinema.ratecard.frc_total_amount">
                              {{
                                ((
                                  parseFloat(
                                    singleCinema.itemcost_price.costprice || 0
                                  ) /
                                  parseFloat(
                                    singleCinema.ratecard.frc_total_amount || 0
                                  )
                                ).toFixed(MIN_FRACTION_DIGITS) *
                                  100)
                                  | RoundOff
                              }}%
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              class="col-lg-1 d-flex align-items-center justify-content-center"
            >
              <!-- <button
                v-if="CinemaIndex == 0"
                @click.prevent.stop="addCinemaSetting(CinemaIndex)"
                class="btn-transparent"
                :disabled="isRoleID"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button> -->
              <button
                v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>

            <!-- DAYS -->
            <div class="row ml-2" v-if="false">
              <div class="col-lg-3 col-xl-2">
                <div>{{ $t("select") }} {{ $t("days") }}:</div>
              </div>
              <div class="col-lg-9 col-xl-10 pl-0">
                <div class="row">
                  <b-form-checkbox
                    :disabled="
                      role_id == 1 || role_id == 2
                        ? false
                        : singleCinema.cinemaFlag
                    "
                    v-for="(weekdaysLoop, weekdaysKey) in singleCinema.weekDays"
                    :key="weekdaysKey"
                    style="min-width: 125px"
                    class="j-checkbox mb-3"
                    @change="onChangeWeekdays($event, weekdaysKey, CinemaIndex)"
                    v-model="singleCinema.weekDays[weekdaysKey]"
                  >
                    <div class="text-capitalize">{{ weekdaysKey }}</div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <!-- CHARGE SETTINGS -->
            <div class="col-md-12" v-if="false">
              <div>
                <div class="font-weight-bold mb-2">
                  {{ $t("add") }} {{ $tc("charge", 2) }}
                </div>
              </div>

              <div
                class="col-12"
                v-for="(
                  cinemaCharge, cinemaChargesListIndex
                ) in singleCinema.cinemaChargesList"
                :key="cinemaChargesListIndex"
              >
                <div class="row">
                  <!-- IMAGE DIMENSION -->
                  <div class="col-md-5 mb-4">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                        <label>{{ cinemaCharge.ct_name }}</label>
                      </div>
                    </div>
                    <!-- <p class="error_msg">Invalid Entry</p> -->
                  </div>
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label
                            >{{ cinemaCharge.pas_charge_value
                            }}{{
                              cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                            }}</label
                          >
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div
                          class="d-flex justify-content-center align-items-center p-3"
                        >
                          <label>{{
                            cinemaCharge.cinemacharges.toFixed(4)
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Net Amount:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_net_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Gross Total:</span>
                    <span
                      >{{ currencyData.curr_code }}
                      {{
                        singleCinema.ratecard.frc_total_amount.toFixed(MIN_FRACTION_DIGITS)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="text-right">
                  <div>
                    <span class="font-weight-bold">Food Cost %:</span>
                    <span v-if="singleCinema.ratecard.frc_total_amount"
                      >{{
                        ((
                          singleCinema.itemcost_price.costprice /
                          singleCinema.ratecard.frc_total_amount
                        ).toFixed(MIN_FRACTION_DIGITS) *
                          100)
                          | RoundOff
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
        >
          <button
            @click.prevent.stop="addCinemaSetting()"
            class="btn-transparent add-more-button"
          >
            <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
          </button>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/customization"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
      title="FNB Image"
    >
      <img :src="_GetImagePath(fnb_item.item_image_url)" class="img-fluid" />
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import CinemasService from "@/services/CinemasService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";
import MovieService from "@/services/MovieService";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      AllCinemaChargeSettingsArray: [],
      removed_alternate_items: [],
      selected_alternate_items: [],
      alternate_items_list: [],
      ms_food_categoriesCopy: [],
      searchFoodCategories: "",
      set_width: null,
      set_height: null,
      showModal: false,
      isRoleID: true,
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      loader: this.$loading,
      submitted: false,
      errmsg: "",
      cinemaList: [],
      cinemaListCopy: [],
      currencyData: [],
      btenable: false,
      fnb_item: {
        item_id: "",
        item_name: "",
        item_description: "",
        item_code: "",
        fc_id: "",
        recipe_id: "",
        customization_common_id: null,
        is_sundry: "N",
        item_is_veg: true,
        item_is_recipe: "",
        item_image_url: "",
        includes_egg: true,
        is_package_item: false,
        item_is_active: true,
        selected_alternate_items: [],
        selected_customizations: [],
      },

      customizations: [],
      customizationsCopy: [],
      searchCustomization: "",
      customization_name: "",

      CinemaPriceSettings: [
        {
          selectedCinema: "",
          selectedCinemas: [],
          cinema_id: null,
          recipe_label: "",
          cinemaFlag: false,
          //ITEM COST PRICE
          itemcost_price: {
            itc_id: "",
            cinema_id: "",
            v_id: "",
            item_id: "",
            costprice: "",
            fp_is_active: true,
          },
          //RATE CARD

          selectedCinema: "",
          cinemaList: [],
          currencyData: [],
          ratecard: {
            frc_id: null,
            cinema_id: null,
            frc_name: Math.floor(1000 + Math.random() * 9000),
            frc_amount: 0,
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_is_active: "N",
            frc_net_amount: 0,
            frc_total_amount: 0,
            curr_code: null,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          weekDays: {
            selectAll: false,
            sunday: false,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
          },
          ms_fnb_price: {
            cinema_id: "",
            item_id: "",
            currency_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: "",
            fp_to_date: "",
            fp_is_active: true,
            fp_sunday: true,
            fp_monday: true,
            fp_tuesday: true,
            fp_wednesday: true,
            fp_thursday: true,
            fp_friday: true,
            fp_saturday: true,
          },
        },
      ],

      ImageLength: "",
      ms_food_categories: [],
      BaseURL: "",
      recipes: [],
      recipe_label: "Select Recipe",
      fc_parent_label: "Select Food Category",
      occupiedCinemas: [],
      role_id: null,
      removedPriceDetails: [],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      FnbItemContent: [],
      tempFnbContentData: [],
      fnbId: "",
      notempty: [false, false, false, false, false, false],
    };
  },
  created() {
    // this.getMovieContentLangauge();
  },
  beforeMount() {
    this.fnb_item.item_code = this.$route.query.item_code;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.role_id = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
    this.getGlobalOptions();
  },
  computed: {
    list() {
      return this.cinemaChargesList;
    },
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
    qfx_tax_structure() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure);
    },
     mif_tax_calculation() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.mif_tax_calculation);
    },
    fractionDigits() {
      let fracDigit = 3;
      if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
        fracDigit = 2;
      } else {
        fracDigit = 3;
      }
      return fracDigit;
    },
    ...mapGetters(["finalImagePath"]),
  },
  watch: {
    finalImagePath(newval) {
      this.fnb_item.item_image_url = newval;
    },
  },
  async mounted() {
    await this.getFnbItemDetails();
    await this.getAlternateItems();
    // await this.getItemCostPrice();
    // await this.getFnbPricing();
    await this.getRecipeList();
    await this.getFoodCategoiresList();
    await this.getAllCinemaChargeSettings();
    // await this.getCustomizationList();
  },
  methods: {
    getAllCinemaChargeSettings() {
      this.AllCinemaChargeSettingsArray = [];
      PosFnbService.GetAllTaxSettings()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length) {
            this.AllCinemaChargeSettingsArray = data.Records;
          } else {
            console.log("getAllCinemaChargeSettings", data);
          }
        })
        .catch((err) => {
          console.log("Error: getAllCinemaChargeSettings", err);
        });
    },
    getMovieContentLangauge: function (FnbContent) {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers(FnbContent);
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    onChangeItemName(event, type) {
      this.FnbItemContent.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.item_name = event.target.value;
          } else if (type == "desc") {
            x.item_description = event.target.value;
          }
        }
      });
    },
    makeLangContainers: function (FnbContent) {
      let Obj;
      console.log("FnbContent", FnbContent);
      this.ContentLanguages.map((x, i) => {
        let Array1 = FnbContent.filter((y) => {
          return y.content_lang_id == x.langaugeId;
        });
        if (Array1.length > 0) {
          x["mfc_id"] = Array1[0].mfc_id;
          x["fnb_id"] = Array1[0].fnb_id;
          x["item_name"] = Array1[0].item_lang_name;
          x["item_description"] = Array1[0].item_lang_description;
          if (Array1[0].item_lang_name && Array1[0].item_lang_description) {
            this.notempty[i] = true;
          }
        } else {
          x["fnb_id"] = this.fnbId;
          x["item_name"] = "";
          x["item_description"] = "";
        }
      });
      this.FnbItemContent = this.ContentLanguages;
      console.log("hjhf", this.ContentLanguages);
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    resetFromDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_from_date = "";
    },
    resetToDate(index) {
      this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date = "";
    },
    clearCustomisation() {
      this.customization_name = "";
    },
    removeAlternateItem(item) {
      this.removed_alternate_items.push(item);
    },
    getAssignedAlternateItems: function () {
      PosFnbService.GetAssignedAlternateItems({
        item_code: this.fnb_item.item_code,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.selected_alternate_items = data.Records;
          } else {
          }
        })
        .catch((error) => {
          console.log("Catch Error on getAssignedAlternateItems :", error);
        });
    },
    getAlternateItems: function () {
      PosFnbService.GetAlternateItems()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.alternate_items_list = data.Records;
            this.alternate_items_list.filter((x, i) => {
              if (this.fnb_item.item_code == x.item_code) {
                this.alternate_items_list.splice(i, 1);
              }
            });
            console.log("alternate_items_list :>> ", this.alternate_items_list);
            this.getAssignedAlternateItems();
          } else {
          }
        })
        .catch((error) => {
          console.log("Catch Error on getAlternateItems :", error);
        });
    },
    onChangeSettingName: function (event, item, index) {
      this.CinemaPriceSettings[index].selectedChargeSettingName =
        item.pas_charge_setting_name;
      this.getCinemaCharges(
        this.CinemaPriceSettings[index].ratecard.cinema_id,
        index
      );
    },
    getCinemaCharges: async function (id, index) {
      this.CinemaPriceSettings[index].cinemaChargesList = [];
      let checkFlag = true;
       if(this.AllCinemaChargeSettingsArray.length) {
        let tempCinemaTaxSettings = this.AllCinemaChargeSettingsArray.filter((x) =>x.cinema_id == id && x.pas_charge_setting_name == this.CinemaPriceSettings[index].selectedChargeSettingName);
        if(tempCinemaTaxSettings && tempCinemaTaxSettings.length) {
          let selectedChargeSetting = tempCinemaTaxSettings[0];
          this.CinemaPriceSettings[index].cinemaChargesList = selectedChargeSetting['charge_array'];
          let promises = this.CinemaPriceSettings[
              index
            ].cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation(index);
            });
        } else {
          checkFlag = false;
        }
      } else {
        checkFlag = false;
      }
      if(!checkFlag) {
      let payload = {
        pas_charge_setting_name:
          this.CinemaPriceSettings[index].selectedChargeSettingName,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemaPriceSettings[index].cinemaChargesList = data.Records;
            let promises = this.CinemaPriceSettings[
              index
            ].cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation(index);
            });
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("catch error on GetCinemaCharges :", error);
        });
      }
    },
    onSearchFoodCategories: function () {
      if (this.searchFoodCategories && this.searchFoodCategories.length > 0) {
        this.ms_food_categories = this.ms_food_categoriesCopy.filter((x) => {
          if (
            x.fc_category
              .toLowerCase()
              .includes(this.searchFoodCategories.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.ms_food_categories = this.ms_food_categoriesCopy;
      }
    },
    onSelectFnbItem: function (fnbItem, index) {
      this.CinemaPriceSettings[index].itemcost_price.item_id = parseInt(
        fnbItem.recipe_id
      );

      this.getItemCostPriceNew(
        this.CinemaPriceSettings[index].itemcost_price.cinema_id,
        fnbItem.recipe_id,
        index
      );
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
    showFnbImage: function () {
      console.log("object");
      this.$refs["preview-modal"].show();
    },
    onChangeWeekdays: function (event, keyname, index) {
      if (keyname !== "selectAll") {
        this.CinemaPriceSettings[index].weekDays["selectAll"] = false;
      }

      let len = Object.keys(this.CinemaPriceSettings[index].weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "selectAll"
            ? (this.CinemaPriceSettings[index].weekDays[x] = true)
            : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
          x !== "selectAll"
            ? (this.CinemaPriceSettings[index].weekDays[x] = false)
            : "";
        });
      } else if (
        keyname !== "selectAll" &&
        this.CinemaPriceSettings[index].weekDays.selectAll
      ) {
        this.CinemaPriceSettings[index].weekDays["selectAll"] = false;
      }
    },
    onSearchCustomization: function () {
      if (this.searchCustomization && this.searchCustomization.length > 0) {
        this.customizations = this.customizationsCopy.filter((x) => {
          if (
            x.customization_name
              .toLowerCase()
              .includes(this.searchCustomization.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.customizations = this.customizationsCopy;
      }
    },
    getFnbItemDetails: function () {
      PosFnbService.GetFnbItem({ item_code: this.fnb_item.item_code,  onlyActive: 'Y' })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            for (var i = 0; i < data.Records.length - 1; i++) {
              this.addCinemaSetting(true);
            }
            data.Records.map((x, index) => {
              this.CinemaPriceSettings[index]["item_id"] = x.item_id;
              this.CinemaPriceSettings[index]["isLoading"] = false;
              this.CinemaPriceSettings[index]["isNewCinema"] = false;
              this.CinemaPriceSettings[index].itemcost_price.item_id =
                x.recipe_id;
              this.getItemCostPrice(x.item_id, index);
            });

            this.fnb_item = data.Records[0];
            this.fnbId = data.Records[0].item_id;
            this.getMovieContentLangauge(data.FnbContent);
            // this.customization_name = data.Records[0].customization_name;
            this.fnb_item.is_sundry = data.Records[0].is_sundry || "N";
            this.fnb_item.item_is_veg =
              this.fnb_item.item_is_veg == "Y" ? true : false;
            this.fnb_item.includes_egg =
              this.fnb_item.includes_egg == "Y" ? true : false;

            this.fnb_item.is_package_item =
              this.fnb_item.is_package_item == "Y" ? true : false;

            this.fnb_item.item_is_active =
              this.fnb_item.item_is_active == "Y" ? true : false;

            this.recipe_label = this.fnb_item.recipe_name;
            this.fc_parent_label = this.fnb_item.fc_category;
            this.getCustomizationList(data.Records[0].customization_common_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getItemCostPriceNew: function (cinema_id, item_id, index) {
      if (cinema_id && item_id) {
        PosFnbService.GetItemsCostPrice({ cinema_id, item_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.CinemaPriceSettings[index].itemcost_price.costprice =
                data.ItemCostPrice.toFixed(this.MIN_FRACTION_DIGITS);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getCurrencyCode: function (currencyid) {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id: currencyid,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getItemCostPrice: function (item_id, index) {
      let payload = {
        tableName: "item_cost_price",
        itc_is_active: "Y",
        item_id: item_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.recipes = data.Records;
            // console.log("ITC", data.Records);
            // let obj = data.Records[0];
            // for (var i = 0; i < data.Records.length - 1; i++) {
            //   this.addCinemaSetting();
            // }

            data.Records.map((obj) => {
              this.occupiedCinemas.push({
                cine_id: obj.cinema_id,
                arrayIndex: index,
              });
              this.getCinemaName(obj.cinema_id, index);
              this.getPasSettingName(obj.cinema_id, index);
              this.CinemaPriceSettings[index].cinema_id = obj.cinema_id;
              this.CinemaPriceSettings[index].recipe_label =
                this.CinemaPriceSettings[index].itemcost_price.item_id &&
                String(this.CinemaPriceSettings[index].itemcost_price.item_id)
                  .length > 0
                  ? this.recipe_label
                  : "";
              this.CinemaPriceSettings[index].itemcost_price.cinema_id =
                obj.cinema_id;
              this.CinemaPriceSettings[index].itemcost_price.itc_id =
                obj.itc_id;
              // this.CinemaPriceSettings[
              //   index
              // ].itemcost_price.item_id = this.fnb_item.item_id;
              this.CinemaPriceSettings[index].itemcost_price.costprice =
                obj.itc_cost_price;
              this.CinemaPriceSettings[index].itemcost_price.fp_is_active =
                obj.itc_is_active;
            });
            this.getFnbPricing(item_id, index);
            this.getMultipleCinemasData();
            console.log("this.occupiedCinemas :>> ", this.occupiedCinemas);
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getMultipleCinemasData: function () {
      MasterService.getMultipleCinemasData(this.occupiedCinemas)
        .then((response) => {
          const { data } = response;

          if (data.status && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.occupiedCinemas.map((x) => {
                data.Records.filter((y) => {
                  if (y.cine_id == x.cine_id) {
                    this.CinemaPriceSettings[x.arrayIndex].selectedCinema =
                      y.cine_name;
                    this.CinemaPriceSettings[x.arrayIndex].cinemaFlag = true;
                    this.CinemaPriceSettings[x.arrayIndex].selectedCinemas.push(
                      y
                    );
                  }
                });

                this.cinemaListCopy.filter((z, index) => {
                  if (z.cine_id == x.cine_id) {
                    this.cinemaListCopy.splice(index, 1);
                  }
                });
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCinemaName(cinema_id, index) {
      this.cinemaList.map((x) => {
        if (String(cinema_id) == String(x.cine_id)) {
          this.CinemaPriceSettings[index].selectedCinema = x.cine_name;
          this.CinemaPriceSettings[index].selectedCinemas.push(x);
        }
      });
    },
    getCustomizationList: function (customization_common_id) {
      let payload = {
        limit: null,
        currentPage: null,
        searchKey: "",
        searchValue: "",
      };
      PosFnbService.GetCustomizationList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.customizations = data.Records;
            this.customizationsCopy = data.Records;
            this.customizations.map((x) => {
              if (x.customization_common_id == customization_common_id) {
                this.customization_name = x.customization_name;
                return;
              }
            });
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCustomization(value) {
      this.customization_name = value.customization_name;
      this.fnb_item["customization_common_id"] = value.customization_common_id;
    },
    addCinemaSetting: function (index) {
      this.getGlobalOptions();
      this.CinemaPriceSettings.push({
        selectedCinema: "",
        cinema_id: null,
        selectedCinemas: [],
        recipe_label: "",
        report_code: "",
        gl_account: "",
        gl_desc: "",
        item_id: null,
        isNewCinema: true,
        //ITEM COST PRICE
        itemcost_price: {
          itc_id: "",
          cinema_id: "",
          v_id: "",
          item_id: "",
          costprice: "",
          fp_is_active: true,
        },
        //RATE CARD

        selectedCinema: "",
        cinemaList: [],
        currencyData: [],
        ratecard: {
          frc_id: null,
          cinema_id: null,
          frc_name: Math.floor(1000 + Math.random() * 9000),
          frc_amount: "",
          currency_id: null,
          frc_is_active_inclusivtax: "Y",
          frc_is_active: "N",
          frc_net_amount: 0,
          frc_total_amount: 0,
          curr_code: null,
        },
        selectedChargeSettingName: "",
        pas_setting_name_list: [],
        cinemaChargesList: [],
        //FNB Pricing
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
        ms_fnb_price: {
          fp_id: "",
          cinema_id: "",
          item_id: "",
          currency_id: "",
          fp_id: "",
          fnb_rate_card_id: "",
          fp_amount: "",
          fp_total_amount: "",
          fp_from_date: new Date(),
          fp_to_date: "",
          fp_is_active: true,
          fp_sunday: true,
          fp_monday: true,
          fp_tuesday: true,
          fp_wednesday: true,
          fp_thursday: true,
          fp_friday: true,
          fp_saturday: true,
        },
      });
    },
    setDaysValue: function (voucherDays, index) {
      let days = {
        sunday: "fp_sunday",
        monday: "fp_monday",
        tuesday: "fp_tuesday",
        wednesday: "fp_wednesday",
        thursday: "fp_thursday",
        friday: "fp_friday",
        saturday: "fp_saturday",
      };
      if (voucherDays) {
        Object.keys(days).map((x) => {
          this.CinemaPriceSettings[index].weekDays[x] =
            voucherDays[days[x]] === "Y" ? true : false;
        });

        let array = Object.keys(
          this.CinemaPriceSettings[index].weekDays
        ).filter(
          (x) =>
            x !== "selectAll" && !this.CinemaPriceSettings[index].weekDays[x]
        );
        if (array.length === 0) {
          this.CinemaPriceSettings[index].weekDays["selectAll"] = true;
        }
      }
    },
    onChangeRatecardAmount: function (event, index) {
      this.cinemaChargesCalculation(index);
    },
    OnSwitchHandler: function (event, index) {
      this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax =
        event;
      this.cinemaChargesCalculation(index);
    },
    getFnbPricing: function (item_id, index) {
      let payload = {
        tableName: "ms_fnb_price",
        fp_is_active: "Y",
        item_id: item_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.recipes = data.Records;
            // console.log("ITC", data.Records);
            // let obj = data.Records[0];
            data.Records.map((obj) => {
              // this.ms_fnb_price = obj;
              this.setDaysValue(obj, index);
              this.CinemaPriceSettings[index].ms_fnb_price.item_id = item_id;
              this.CinemaPriceSettings[index].ms_fnb_price.fp_id = obj.fp_id;
              this.CinemaPriceSettings[index].ms_fnb_price.cinema_id =
                obj.cinema_id;
              this.CinemaPriceSettings[index].report_code =
                obj.report_code || null;
              this.CinemaPriceSettings[index].gl_account =
                obj.gl_account || null;
              this.CinemaPriceSettings[index].gl_desc = obj.gl_desc || null;
              this.CinemaPriceSettings[index].ms_fnb_price.fnb_rate_card_id =
                obj.fnb_rate_card_id;
              this.CinemaPriceSettings[index].ms_fnb_price.fp_from_date =
                new Date(obj.fp_from_date);
              this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date =
                obj.fp_to_date && isValidDate(new Date(obj.fp_to_date))
                  ? new Date(obj.fp_to_date)
                  : "";
              this.getEditRatecardList(obj.fnb_rate_card_id, index);
            });
            function isValidDate(d) {
              if (Object.prototype.toString.call(d) === "[object Date]") {
                // it is a date
                if (isNaN(d.getTime())) {
                  return false;
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  return true;
                  // date is valid
                }
              } else {
                return false;
                // not a date
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getEditRatecardList: function (id, index) {
      PosFnbService.GetRatecardById({ id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.CinemaPriceSettings[index].ratecard = {
                ...this.CinemaPriceSettings[index].ratecard,
                ...data.Records[0],
              };

              if (data.Records[0]["frc_pas_setting_name"]) {
                this.CinemaPriceSettings[index]["selectedChargeSettingName"] =
                  data.Records[0]["frc_pas_setting_name"]
                    ? data.Records[0]["frc_pas_setting_name"]
                    : "";
              }
              // this.getCinemaList(data.Records[0].cinema_id);
              // this.ratecard.currency_id = data.Records[0].curr_id;
              this.CinemaPriceSettings[index].cinemaChargesList =
                data.Records[0].chargesList || [];
              this.cinemaChargesCalculation(index);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFloat(val = "0", fractionDigits = this.fractionDigits) {
      let parsed = parseFloat(String(val) || "0") || parseFloat("0");
      return +parseFloat(parsed.toFixed(fractionDigits));
    },
    cinemaChargesCalculation: function (index) {
      this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );

      let FinalAmount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_total_amount || 0
      );
      if (this.qfx_tax_structure) {
        console.log("CALC qfx_tax_structure");
        let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );
        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = VAT_AMT;
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = NET_1_AMT;
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = NET_2_AMT;
          }
          if (x.pas_id == misc_product_rate_pas_id) {
            x["cinemacharges"] = NET_3_AMT;
          }
        });

        this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          BASE_RATE + NET_3_AMT
        );

        this.$forceUpdate();
      } else if (this.mif_tax_calculation) {
           let grosss = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let nets = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
          .filter((g) => g.pas_is_percentage === "Y");

        let misc_products = this.getSafe(
          () => this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
          []
        )
          .filter((g) => g.pas_is_percentage === "N")
          .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

        console.log({
          nets,
          grosss,
          misc_products,
          taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
            (x) => x
          ),
        });

        let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
        let vat_percent = this.getFloat(
          this.getSafe(() => grosss[0].pas_charge_value, 0),
          2
        );

        let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
        let net_1_percent = this.getFloat(
          this.getSafe(() => nets[0].pas_charge_value, "0"),
          2
        );

        let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
        let net_2_percent = this.getFloat(
          this.getSafe(() => nets[1].pas_charge_value, "0"),
          2
        );

        let misc_product_rate_pas_id = this.getSafe(
          () => misc_products[0].pas_id
        );
        let misc_product_rate_1 = this.getFloat(
          this.getSafe(() => misc_products[0].pas_charge_value, "0"),
          2
        );

        let all_mis_product_sum = 0;
        if (misc_products && misc_products.length) {
          all_mis_product_sum =
            this.getFloat(
              misc_products.reduce(
                (acc, { pas_charge_value }) =>
                  acc + parseFloat(pas_charge_value),
                0
              ),
              3
            ) || 0;
        }

        let misc_rate_exist =
          misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
        let amount = this.getFloat(FinalAmount);

        /** Gross */
        let G = amount;
        /** Taxable/Net */
        let E = this.getFloat(amount / (1 + vat_percent / 100));
        /** VAT */
        let F = this.getFloat((vat_percent / 100) * E);
        /** 3D/Prod */
        let B = this.getFloat(all_mis_product_sum || 0);
        /** Ticket Rate */
        let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
        let A = this.getFloat((E - B) / totalPerCentOfA);
        /** Film Dev Tax */
        let C = this.getFloat((net_1_percent / 100) * A);
        /** State & Local Ent Tax */
        let D = this.getFloat((net_2_percent / 100) * A);

        console.log({
          amount,
          vat_percent,
          net_1_percent,
          net_2_percent,
          totalPerCentOfA,
          misc_rate_exist,
          misc_product_rate_1,
        });
        console.log({
          Gross: G,
          Net: E,
          VAT: F,
          FDT: C,
          SLE: D,
          "3D": B,
          TicketRate: A,
          ProductRate: B,
        });

        let NET_AMT = E;
        let BASE_RATE = A;
        let NET_1_AMT = C;
        let NET_2_AMT = D;
        let NET_3_AMT = B; // misc_product_rate_1
        let VAT_AMT = F;
        let Gross = G;

        this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
          if (x.pas_id == vat_pas_id) {
            x.cinemacharges = this.getFloat(VAT_AMT, 2);
          }
          if (x.pas_id == net_1_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_1_AMT, 2);
          }
          if (x.pas_id == net_2_pas_id) {
            x["cinemacharges"] = this.getFloat(NET_2_AMT, 2);
          }
          if (x.pas_is_percentage == "N") {
            let findIndex = misc_products.findIndex(
              (mis) => mis.pas_id == x.pas_id
            );
            if (findIndex > -1) {
             x["cinemacharges"] = parseFloat(
                misc_products[findIndex]["pas_charge_value"]
              ).toFixed(2);
            }
          }
        });

        // this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
        //   BASE_RATE + NET_3_AMT
        // );
        this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          BASE_RATE
        );

        this.$forceUpdate();
      } else {
        this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
          if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "N"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                (parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Plus", index);
          } else if (
            this.CinemaPriceSettings[index].ratecard
              .frc_is_active_inclusivtax === "Y"
          ) {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges =
                ((parseFloat(
                  this.CinemaPriceSettings[index].ratecard.frc_amount
                ) /
                  this.calculatePercentageCharge(index)) *
                  parseFloat(x.pas_charge_value)) /
                100;
            }
            this.calculateNetAmount(x, "Minus", index);
          }
          if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            x.cinemacharges =
              parseFloat(x.pas_charge_value) *
              this.calculateTaxableCharge(index);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            x.cinemacharges = parseFloat(x.pas_charge_value);
          }
          return x;
        });
        this.$forceUpdate();
      }
    },
    cinemaChargesCalculation_old: function (index) {
      this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );
      this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
        this.CinemaPriceSettings[index].ratecard.frc_amount
      );

      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (
          this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax ===
          "N"
        ) {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.CinemaPriceSettings[index].ratecard.frc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Plus", index);
        } else if (
          this.CinemaPriceSettings[index].ratecard.frc_is_active_inclusivtax ===
          "Y"
        ) {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              ((parseFloat(
                this.CinemaPriceSettings[index].ratecard.frc_amount
              ) /
                this.calculatePercentageCharge(index)) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Minus", index);
        }
        if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          x.cinemacharges =
            parseFloat(x.pas_charge_value) * this.calculateTaxableCharge(index);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          x.cinemacharges = parseFloat(x.pas_charge_value);
        }
        return x;
      });
      this.$forceUpdate();
    },
    calculatePercentageCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation, index) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_total_amount +=
            parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.cinemacharges
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          this.CinemaPriceSettings[index].ratecard.frc_net_amount -= parseFloat(
            x.pas_charge_value
          );
        }
      }
    },
    removeCinemaSettings: function (cinemaIndex) {
      if (
        this.role_id == 3 &&
        this.CinemaPriceSettings[cinemaIndex].cinemaFlag
      ) {
        this.$toasted.show(
          "You are not authorized to remove other cinemas details."
        );
      } else {
        this.removedPriceDetails.push(this.CinemaPriceSettings[cinemaIndex]);
        console.log("this.removedPriceDetails :>> ", this.removedPriceDetails);
        this.CinemaPriceSettings.splice(cinemaIndex, 1);
      }
    },
    calculateTaxableCharge: function (index) {
      let finalvalue = 1;
      this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
        //Pick only items that are taxable
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    onDropdownChange: function (item, index) {
      // this.cinemaListCopy.push(item.cine_id);
      this.CinemaPriceSettings[index].selectedCinema = item.cine_name;
      this.CinemaPriceSettings[index].cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].itemcost_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ms_fnb_price.cinema_id = item.cine_id;
      this.CinemaPriceSettings[index].ratecard.cinema_id = item.cine_id;
      // this.cinemaListCopy = [];
      // this.cinemaList.map((x) => {
      //   let arr = this.CinemaPriceSettings.filter((y) => {
      //     return y.cinema_id == x.cine_id;
      //   });
      //   if (arr.length == 0) {
      //     this.cinemaListCopy.push(x);
      //   }
      // });
      this.cinemaListCopy.map((x, index) => {
        if (x.cine_id == item.cine_id) {
          this.cinemaListCopy.splice(index, 1);
        }
      });
      if (item.currency_id == null && item.currency_id == "") {
        this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value;
      } else {
        this.getCurrencyCode(item.currency_id);
      }
      this.getPasSettingName(item.cine_id, index);
    },
    getPasSettingName: function (id, index) {
      this.CinemaPriceSettings[index].pas_setting_name_list = [];
      if (this.AllCinemaChargeSettingsArray.length) {
        this.CinemaPriceSettings[index].pas_setting_name_list =
          this.AllCinemaChargeSettingsArray.filter((x) => x.cinema_id == id);
      } else {
        CinemasService.GetCinemaSettingNameByCinemaId({ id })
          .then(async (response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemaPriceSettings[index].pas_setting_name_list =
                data.Records;
            } else {
              // Show Error Message Here
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            this.$toasted.show(error);
          });
      }
    },
    getGlobalOptions: function () {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                this.CinemaPriceSettings.map((y, index) => {
                  this.CinemaPriceSettings[index].ratecard.currency_id =
                    x.go_value || null;
                  this.CinemaPriceSettings[index].ms_fnb_price.currency_id =
                    x.go_value || null;
                });
              }
            });
          } else {
            // Show Error
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          //Catch Error
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    getCinemaList: function (cinema_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      MasterService.GetCinemas({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.cinemaList = data.Records;
              this.cinemaListCopy = data.Records;
              this.cinemaList.map((x) => {
                if (String(cinema_id) == String(x.cine_id)) {
                  // this.selectedCinema = x.cine_name;
                }
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRecipeList: function () {
      let payload = {
        tableName: "ms_recipes",
        recipe_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.recipes = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getFoodCategoiresList: function () {
      let payload = {
        tableName: "ms_food_categories",
        fc_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            this.ms_food_categoriesCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },

    // setImage: function(e) {
    //   this.file = e.target.files[0];
    //   this.filename = e.target.files[0]["name"];

    //   // console.log("file.type.indexOf :", file.type);
    //   if (this.file.type.indexOf("image/") === -1) {
    //     this.$toasted.show("Please select an image file");
    //     return;
    //   }
    //   if (typeof FileReader === "function") {
    //     const reader = new FileReader();
    //     reader.onload = event => {
    //       this.imgSrc = event.target.result;
    //       this.width = 129;
    //       this.height = 192;
    //       // this.$cropper.setAspectRatio(1);
    //       // rebuild cropperjs with the updated source
    //       this.$bvModal.show("imagecropper");
    //       e.target.value = "";
    //     };
    //     reader.readAsDataURL(this.file);
    //   } else {
    //     // alert("Sorry, FileReader API not supported");
    //   }
    // },

    // cropImage() {
    //   // get image data for post processing, e.g. upload or setting image src
    //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    //   var block = this.cropImg.split(";");
    //   // Get the content type of the image
    //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
    //   // get the real base64 content of the file
    //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
    //   // Convert it to a blob to upload
    //   var blob1 = this.b64toBlob(realData, contentType);
    //   this.uploadImage(blob1, this.filename);
    // },
    // b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || "";
    //   sliceSize = sliceSize || 512;

    //   var byteCharacters = atob(b64Data);
    //   var byteArrays = [];

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize);

    //     var byteNumbers = new Array(slice.length);
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }

    //     var byteArray = new Uint8Array(byteNumbers);

    //     byteArrays.push(byteArray);
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType });
    //   return blob;
    // },

    // uploadImage: function(image, filename) {
    //   let loader = this.$loading.show();

    //   let self = this;
    //   let formData = new FormData();
    //   formData.append("image", image, filename);
    //   formData.append("imagePath", "FnB Item Image");
    //   MasterService.GlobalUploadImage(formData)
    //     .then(response => {
    //       const { data } = response;
    //       data.message ? this.$toasted.show(data.message) : "";
    //       if (data.status) {
    //         self.fnb_item.item_image_url = data.path;
    //         this.$bvModal.hide("imagecropper");
    //       }
    //       self.BaseURL = data.BaseURL;
    //     })
    //     .catch(error => {
    //       alert(
    //         "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     })
    //     .finally(() => {
    //       setTimeout(() => loader.hide(), 1000);
    //     });
    // },

    onResetForm: function () {
      this.fnb_item = {
        fc_id: "",
        item_code: "",
        item_description: "",
        recipe_id: "",
        item_is_veg: true,
        includes_egg: true,
        item_is_recipe: "",
        item_image_url: "",
        item_is_active: false,
      };
      this.recipe_label = "";
      this.fc_parent_label = "";
    },
    onFinalSubmit: function (flag) {
      // let loader = this.$loading.show();
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (false) {
          this.errmsg = "Please Select Food Image.";
          return;
        } else {
          if (valid) {
            let loader = this.$loading.show();
            if (this.fnb_item.item_is_veg == true) {
              this.fnb_item.includes_egg = false;
            }
            let payload = {
              CinemaPriceSettings: this.CinemaPriceSettings,
              removedPriceDetails: this.removedPriceDetails,
              fnb_item: {
                ...this.fnb_item,
                selected_alternate_items: this.selected_alternate_items,
                removed_alternate_items: this.removed_alternate_items,
              },
              FnbItemContent: this.FnbItemContent,
              isCustomization: true,
            };
            PosFnbService.UpdateFnbItem(payload)
              .then((response) => {
                const { data } = response;
                // loader.hide();
                if (data && data.status) {
                  this.onResetForm();
                  this.$toasted.show(data.message);
                  this.$router.push({
                    path: "/fnb/customization",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                loader.hide();
              });
          }
        }
      });
    },
    CheckEmptyContent: function (fnbContent, index) {
      console.log("im in");
      if (fnbContent.langauge.toLowerCase() !== "english") {
        if (fnbContent.item_name && fnbContent.item_description) {
          this.notempty[index] = true;
        } else {
          this.notempty[index] = false;
        }
      }
    },
  },
};
</script>

<style>
.clearDropDownBtn {
  position: absolute;
  left: 87%;
  z-index: 9999;
  width: auto;
  border: none;
  height: auto;
  font-size: 14px;
  color: #000000;
  font-weight: bold;
  background-color: transparent;
}

.chargeSettingRow {
  background: #e9ecef;
  padding: 8px;
  border-radius: 10px;
  zoom: 0.9;
}
.chargeSettingInnerWrap {
  border-radius: 15px;
  background: white;
  margin: 3px;
  padding: 12px;
}

.w-250 {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/customizationComponents/editCustomizationV2.vue